import { connect } from "react-redux";

import UebersichtKompressor from "./UebersichtKompressor";

import { makeUndefinedCompressor } from "../model/Kompressor";

export default connect((state, own_props) => ({
	compressor: state.ablauf.compressors[own_props.match.params.compressorIndex] ||
		makeUndefinedCompressor(own_props.match.params.compressorIndex)
}))(UebersichtKompressor);
